<div class="flex flex-col">
  <span class="text-slate-700 font-medium leading-tight">
    <hsuc-safe-script [scriptCode]="label"></hsuc-safe-script>
  </span>
  @if (isExclusive) {
    <span class="text-xs text-blue-500 italic mt-0.5">(None of these)</span>
  }
</div>